import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom"; // Import useParams for route params
import "../css/Ifu.css";

const ifuDocuments = [
  { id: 1, title: "Flowmeter", url: "/IFU/IFU Flowmeter Rev H (NO CE MARK).pdf" },
  { id: 2, title: "InGage Regulator", url: "/IFU/IFU InGage Regulator Rev G (NO CE MARK).pdf" },
  { id: 3, title: "Hose Assembly - Canadian Standard", url: "/IFU/IFU-Hose Assembly - Canadian Standard Rev B.pdf" },
  { id: 4, title: "Hose Assembly", url: "/IFU/IFU-Hose Assembly Rev A.pdf" },
  { id: 5, title: "RW Regulator", url: "/IFU/IFU RW Regulator Rev G (NO CE MARK).pdf" },
  { id: 6, title: "Mass Casualty Assembly", url: "/IFU/IFU Mass Casualty Assembly Rev H (NO CE MARK).pdf" },
  { id: 7, title: "Multilatorr", url: "/IFU/IFU-Multilatorr (2023-12-29) (Rev. A).docx.pdf" },
  { id: 8, title: "Regulator - Octafluoropropane (C3F8)", url: "/IFU/IFU-Regulator-C3F8 Rev C.pdf" },
  { id: 9, title: "Regulator - Sulfur Hexafluoride (SF6)", url: "/IFU/IFU-Regulator-SF6 Rev C.pdf" },
  { id: 10, title: "Regulator - Smiths Medical", url: "/IFU/IFU-Regulator-Smiths Rev C.pdf" },
  { id: 11, title: "Regulator - Test Kit", url: "/IFU/IFU-Regulator-TestKit Rev B.pdf" },
  { id: 12, title: "Resident Nipple Adapter", url: "/IFU/IFU-Resident-Nipple-Adapter Rev A.pdf" },
  { id: 13, title: "Total Oxygen Administration Device (TOAD)", url: "/IFU/IFU-TOAD Rev A.pdf" },
  { id: 14, title: "Transfill Cascade System (TCS)", url: "/IFU/IFU-Transfill Cascade System (2023-12-13) (Rev. A).docx.pdf" },
];

const Ifu = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIfu, setSelectedIfu] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isExpanded, setIsExpanded] = useState(window.innerWidth >= 768); // Start expanded on desktop
  const { id } = useParams(); // Get ID from URL params
  const [oemOpen, setOemOpen] = useState(false);

  const OEM_IDS = new Set([8, 9, 10]);
  const oemIfus = ifuDocuments.filter((d) => OEM_IDS.has(d.id));
  const nonOemIfus = ifuDocuments.filter((d) => !OEM_IDS.has(d.id));


  // Detect screen size change
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsExpanded(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Initialize IFU selection based on URL parameter or search query
  useEffect(() => {
    const init = () => {
      // If an ID is in the URL, select the corresponding IFU
      if (id) {
        const matchedIfu = ifuDocuments.find((ifu) => ifu.id === parseInt(id));
        if (matchedIfu) {
          setSelectedIfu(matchedIfu);
        }
      }
    };

    init(); // Run on mount or when `id` changes
  }, [id]);

  // Filter IFUs based on search
  const filteredIfus = ifuDocuments.filter((doc) =>
    doc.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectIfu = (ifu) => {
    setSelectedIfu(ifu);
    setSearchTerm("");
    if (isMobile) setIsExpanded(false); // Auto-collapse list on mobile
  };

  return (
    <div className="ifu-container">
      <h1>Instructions for Use (IFU)</h1>
      <div className="ifu-content">
        <div className="ifu-sidebar">
          <div className="ifu-header">
            <input
              type="text"
              placeholder="Search IFUs..."
              className="search-bar1"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {isMobile && (
              <button className="toggle-button" onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? "Hide Menu" : "Show Menu"}
              </button>
            )}
          </div>
          <hr className="vertical-line" />

          {isExpanded && (
            <div className="ifu-list-container">
              {searchTerm && (
                <div className="search-dropdown">
                  <ul className="ifu-list">
                    {filteredIfus.length > 0 ? (
                      filteredIfus.map((ifu) => (
                        <li
                          key={ifu.id}
                          className={`ifu-item ${selectedIfu?.id === ifu.id ? "active" : ""}`}
                          onClick={() => handleSelectIfu(ifu)}
                        >
                          {ifu.title}
                        </li>
                      ))
                    ) : (
                      <li className="ifu-item no-results">No results found</li>
                    )}
                  </ul>
                </div>
              )}

              {!searchTerm && (
              <ul className="ifu-list">
                {/* Normal items */}
                {nonOemIfus.map((ifu) => (
                  <li
                    key={ifu.id}
                    className={`ifu-item ${selectedIfu?.id === ifu.id ? "active" : ""}`}
                    onClick={() => handleSelectIfu(ifu)}
                  >
                    {ifu.title}
                  </li>
                ))}
                {/* OEM dropdown header */}
                <li
                  className="ifu-item ifu-oem-toggle"
                  onClick={() => setOemOpen((v) => !v)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") setOemOpen((v) => !v);
                  }}
                >
                  OEM <span className="ifu-oem-caret">{oemOpen ? "▲" : "▼"}</span>
                </li>

                {/* OEM items (hidden until opened) */}
                {oemOpen &&
                  oemIfus.map((ifu) => (
                    <li
                      key={ifu.id}
                      className={`ifu-item ifu-oem-item ${selectedIfu?.id === ifu.id ? "active" : ""}`}
                      onClick={() => handleSelectIfu(ifu)}
                    >
                      {ifu.title}
                    </li>
                  ))}
              </ul>
              )}
            </div>
          )}
        </div>

        <div className="ifu-preview">
          {selectedIfu ? (
            <>
              <div className="pdf-preview-container">
                <iframe
                  src={selectedIfu.url}
                  className="pdf-viewer"
                  width="100%"
                  height="600px"
                  title="PDF Preview"
                ></iframe>
              </div>
              <a href={selectedIfu.url} download className="download-link">
                Download IFU
              </a>
            </>
          ) : (
            <p>Please select an IFU from the list or search above.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Ifu;
